"use client";

import Link from "next/link";
import { useCallback, useEffect, useRef, useState } from "react";

const cookiesAcceptionStatusKey = "cookies-acception-status";

interface ICookiesButtons {
  onClick: () => void;
}

const AcceptButton = ({ onClick }: ICookiesButtons) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const btn = buttonRef.current;
    if (btn) {
      const clickHandler = () => {
        localStorage.setItem(cookiesAcceptionStatusKey, "Accepted");
        onClick();
      };

      btn.addEventListener("click", clickHandler);
      return () => {
        btn.removeEventListener("click", clickHandler);
      };
    }
  }, [onClick]);

  return (
    <button
      className="rounded-md bg-orange font-medium px-5 py-2 duration-200 hover:bg-orangexx/80"
      ref={buttonRef}
    >
      Accept all
    </button>
  );
};

const RejectButton = ({ onClick }: ICookiesButtons) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const btn = buttonRef.current;
    if (btn) {
      const clickHandler = () => {
        localStorage.setItem(cookiesAcceptionStatusKey, "Rejected");
        onClick();
      };

      btn.addEventListener("click", clickHandler);
      return () => {
        btn.removeEventListener("click", clickHandler);
      };
    }
  }, [onClick]);

  return (
    <button className="rounded-md text-white font-medium px-5 py-2 duration-200 hover:bg-gray-500/5">
      Reject optional
    </button>
  );
};

export const CookiesBanner = () => {
  const [cookiesAcceptionStatus, setCookiesAcceptionStatus] = useState<
    string | null
  >();

  useEffect(() => {
    const status = localStorage.getItem(cookiesAcceptionStatusKey);
    setCookiesAcceptionStatus(status);
  }, []);

  if (cookiesAcceptionStatus) return null;

  return (
    <div className="fixed bottom-0 w-full p-4 md:p-16 z-[5000]">
      <div className="relative max-w-[1156px] mx-auto rounded-default bg-new-black-domina text-white shadow-md flex max-md:flex-col items-center justify-between text-sm p-6">
        <div className="md:w-2/3 max-md:mb-2.5 max-md:text-center">
          <p>
            <span>
              We use essential cookies to run this site and optional analytics
              and marketing cookies to understand usage and improve performance.
              You can accept or reject optional cookies at any time.
            </span>{" "}
            <Link href="/policy/privacy-policy">
              <span className="underline text-orange duration-200 hover:text-orange/80">See the Privacy Policy</span>
            </Link>
          </p>
        </div>
        <div className="flex gap-2.5">
          <AcceptButton
            onClick={() => {
              setCookiesAcceptionStatus("Accepted");
            }}
          />
          <RejectButton
            onClick={() => {
              setCookiesAcceptionStatus("Rejected");
            }}
          />
        </div>
      </div>
    </div>
  );
};
